import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "top_bar" }
const _hoisted_2 = { class: "game_left" }
const _hoisted_3 = { class: "game_center" }
const _hoisted_4 = { class: "game_right" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "page" }
const _hoisted_9 = { class: "game_left" }
const _hoisted_10 = { class: "game_center" }
const _hoisted_11 = { class: "game_right" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back(-1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("List.button1")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: '/' }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { class: "back" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("List.button2")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "zhanwei2" }, null, -1)),
    _createVNode(_component_el_tabs, { "tab-position": _ctx.tabPosition }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('List.creationList')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "game",
                key: index
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_image, {
                    src: item.gameCover,
                    fit: "fill"
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", null, _toDisplayString(item.gameTitle), 1),
                  _createElementVNode("p", null, "建立于" + _toDisplayString(item.createTime), 1),
                  _createElementVNode("p", null, "导览编号" + _toDisplayString(item.id), 1),
                  _createElementVNode("p", null, _toDisplayString(item.gameLanguage) + " 不限地区─ 任何地点", 1),
                  _createElementVNode("p", null, _toDisplayString(item.gameDesc.trim()), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (item.updateTime != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("List.tip")) + _toDisplayString(item.updateTime), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h4", {
                    class: "game_right_edit",
                    onClick: ($event: any) => (_ctx.editGame(item.id))
                  }, _toDisplayString(_ctx.$t("List.button3")), 9, _hoisted_6),
                  _createElementVNode("h4", {
                    class: "game_right_delete",
                    onClick: ($event: any) => (_ctx.deleteGame(item.id))
                  }, _toDisplayString(_ctx.$t("List.button4")), 9, _hoisted_7)
                ])
              ]))
            }), 128)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "prev, pager, next",
                total: _ctx.gamesTotal,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["total", "onCurrentChange"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('List.trashCan')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.junkGameList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "game",
                key: index
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_image, {
                    src: item.gameCover,
                    fit: "fill"
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, _toDisplayString(item.gameTitle), 1),
                  _createElementVNode("p", null, "建立于" + _toDisplayString(item.createTime), 1),
                  _createElementVNode("p", null, "导览编号" + _toDisplayString(item.id), 1),
                  _createElementVNode("p", null, _toDisplayString(item.gameLanguage) + " 不限地区─ 任何地点", 1),
                  _createElementVNode("p", null, _toDisplayString(item.gameDesc.trim()), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (item.deleteTime != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 剩余保留天数：" + _toDisplayString(this.getDaysDifference(item.deleteTime)) + "天 ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h4", {
                    class: "game_right_edit",
                    onClick: ($event: any) => (_ctx.restore(item.id))
                  }, "还原", 8, _hoisted_13),
                  _createElementVNode("h4", {
                    class: "game_right_delete",
                    onClick: ($event: any) => (_ctx.completeDelete(item.id))
                  }, _toDisplayString(_ctx.$t("List.button4")), 9, _hoisted_14)
                ])
              ]))
            }), 128)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "prev, pager, next",
                total: _ctx.junkGameListTotal,
                onCurrentChange: _ctx.handleCurrentChange2
              }, null, 8, ["total", "onCurrentChange"])
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["tab-position"])
  ], 64))
}